import { CookieIcon } from './CookieIcon';

/**
 * author: Google
 * id 8E3FB537-B293-41A6-B6C5-B2BE927091F5
 * name cookie
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie.svg
 * tags
 * - Food / Drink 
 */
export const BiscuitIcon = CookieIcon;
export default BiscuitIcon